import routerOptions0 from "/home/ploi/intercomm.cgworks.eu/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}